import React, { useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';

const DeleteUserModal = (props) => {
  const [fetchingData, setFetchingData] = useState(false);

  return (
    <Modal
      onHide={() => props.handleClose()}
      show={props.showDeleteUserModal}
    >
      <Modal.Header closeButton>
        Delete User
      </Modal.Header>
      <Modal.Body>
        Are you sure you wish to delete user {props.userPendingDelete && props.userPendingDelete.email}?
      </Modal.Body>
      <Modal.Footer className='d-flex flex-nowrap'>
        <div className='w-50'>
          <Button
            className='mr-2 pr-3 pl-3 w-100'
            variant='outline-secondary'
            onClick={() => props.handleClose()}
          >
            CANCEL
          </Button>
        </div>
        <div className='w-50'>
          <Button
            disabled={fetchingData}
            className='pr-3 pl-3 w-100'
            variant='danger'
            type='button'
            onClick={async () => {
              setFetchingData(true);
              await props.handleDeleteUser(props.userPendingDelete)
              setFetchingData(false);
              props.handleClose();
            }}
          >
            { fetchingData && (
              <Spinner
                className='mr-2'
                as='span'
                animation='border'
                size='sm'
                role='status'
                aria-hidden='true'
              />
            )}
            DELETE USER
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
};

export default DeleteUserModal;